import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { Shipment, ShipmentCreate, ShipmentFilter } from '../data/shipment';

export function createShipmentService(client: AxiosInstance) {
  return createCrudService<Shipment, ShipmentCreate, ShipmentFilter>(
    client,
    '/sales/Shipment',
    'id',
  );
}

export type ShipmentService = CrudService<Shipment, ShipmentCreate, ShipmentFilter>;
